import { render, staticRenderFns } from "./SettingsTeam.vue?vue&type=template&id=79d03df8&scoped=true"
import script from "./SettingsTeam.vue?vue&type=script&lang=js"
export * from "./SettingsTeam.vue?vue&type=script&lang=js"
import style0 from "./SettingsTeam.vue?vue&type=style&index=0&id=79d03df8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d03df8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79d03df8')) {
      api.createRecord('79d03df8', component.options)
    } else {
      api.reload('79d03df8', component.options)
    }
    module.hot.accept("./SettingsTeam.vue?vue&type=template&id=79d03df8&scoped=true", function () {
      api.rerender('79d03df8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/SettingsTeam.vue"
export default component.exports